import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../user/services/user.service';
import { routeNames } from '../../../../shared/route-names';
import { ReturnUrlService } from '../../services/return-url.service';

@Component({
  standalone: false,
  selector: 'app-oauth2-callback',
  templateUrl: './oauth2-callback.component.html',
  styleUrls: ['./oauth2-callback.component.scss']
})
export class Oauth2CallbackComponent implements OnInit {
  private _router = inject(Router);
  private _userService = inject(UserService);
  private _translateService = inject(TranslateService);
  private _returnUrlService = inject(ReturnUrlService);

  public processing = true;
  public errorMessage = '';

  ngOnInit() {
    this.processCallback();
  }

  private processCallback() {
    // Extract token from URL fragment
    const fragment = window.location.hash.substring(1);
    const params = new URLSearchParams(fragment);
    const token = params.get('token');

    if (token) {
      // Store token first
      localStorage.setItem('token', token);

      // Then fetch user data to validate the token
      this._userService.fetchUser().subscribe({
        next: () => {
          // Clear URL fragment
          window.history.replaceState({}, document.title, window.location.pathname);

          // Navigate to return URL or home
          const returnUrl = this._returnUrlService.getReturnUrlOrDefault(`${routeNames.root}${routeNames.home}`);
          this._router.navigateByUrl(returnUrl);
        },
        error: (error) => {
          console.error('Failed to fetch user data:', error);
          // Token might be invalid, remove it and show error
          localStorage.removeItem('token');
          this.handleAuthError(this._translateService.instant('auth.errors.user_fetch_failed'));
        }
      });
    } else {
      // No token in URL fragment
      this.handleAuthError(this._translateService.instant('auth.errors.token_missing'));
    }
  }

  private handleAuthError(message: string) {
    this.processing = false;
    this.errorMessage = message;

    // Clean up any invalid tokens
    localStorage.removeItem('token');

    // Redirect to login after a short delay
    setTimeout(() => {
      this._router.navigate([`${routeNames.root}${routeNames.auth}/login`], {
        queryParams: { error: 'callback_failed' }
      });
    }, 3000);
  }
}
